exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "._2tTg_dIq7GRxbMmQDVHMOe{margin:0}._6fzBgdhfoN_kINzmZorD0{margin:0;padding-top:.5em}._3lziJxUJ4vR1Z9AbDjPgbY{margin-top:1.21429rem}._2plXSoH8umKyRYFJGR_52U{float:left}._2plXSoH8umKyRYFJGR_52U:after{background-color:#ccc;content:\"\";display:block;height:.07143rem;left:0;position:absolute;width:100%}._3qLsV_DsaFTpchKICEFp-F{float:left}._3LJdrVMQGrP9nL0STdFjjy{padding-bottom:.35714rem}._1bJecfDVk4SKxUmXyXvzSZ{overflow:hidden;padding-bottom:.71429rem}._1bJecfDVk4SKxUmXyXvzSZ>:not(:last-child){margin-right:1.42857rem}._1iID0MMwrU0SPO9XWli4cj{padding-bottom:0;padding-top:.71429rem}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"StudentInformation_container": "_24pd8Sk2xiWTYtAgMqLW-V",
	"StudentInformation_grid": "_2tTg_dIq7GRxbMmQDVHMOe",
	"StudentInformation_item": "_6fzBgdhfoN_kINzmZorD0",
	"StudentInformation_button": "_3lziJxUJ4vR1Z9AbDjPgbY",
	"StudentInformation_periodWrapper": "_2plXSoH8umKyRYFJGR_52U",
	"StudentInformation_periodWrapper_item": "_3qLsV_DsaFTpchKICEFp-F",
	"StudentInformation_periodWrapper_item_label": "_3LJdrVMQGrP9nL0STdFjjy",
	"StudentInformation_periodWrapper_itemContainer": "_1bJecfDVk4SKxUmXyXvzSZ",
	"StudentInformation_content": "_1iID0MMwrU0SPO9XWli4cj"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader?{"root":".","modules":true,"import":false,"importLoaders":1}!../node_modules/postcss-loader/lib?{"config":{"path":"/var/lib/jenkins/workspace/_omni-operation-ui_release_2.7.3/node_modules/omni-common-ui/postcss.config.js"}}!./containers/Group/ProgressReportHFv4/IndividualDevelopmentPlanDetailView/StudentInformation/style.postcss
// module id = 1992
// module chunks = 0